var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbnailUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 36,
    fill: "none",
    viewBox: "0 0 40 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B88FF",
    fillRule: "evenodd",
    d: "M29.66 4H36c2.2 0 4 1.8 4 4v24c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4V8c0-2.2 1.8-4 4-4h6.34l2.46-2.7C13.56.48 14.64 0 15.76 0h8.48c1.12 0 2.2.48 2.94 1.3L29.66 4zM10 20c0 5.52 4.48 10 10 10s10-4.48 10-10-4.48-10-10-10-10 4.48-10 10zm16 0a6 6 0 1 1-12 0 6 6 0 0 1 12 0z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailUploadIcon);
export default __webpack_public_path__ + "static/media/thumbnail_upload_icon.7e29fb0e9571f0044832d832cfa6e9ab.svg";
export { ForwardRef as ReactComponent };